module.exports = __webpack_public_path__ + "static/images/order-yqx.1474583.png";